

export class CheckboxRenderer {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-checkbox');
    this.input.checked = this.params.data.enabled;
    this.input.value = this.params.data.feature;
    this.input.label = this.params.data.feature;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.enabled = event.target.checked;
      params.context.methods.setValue(`card_management_feature_credit_payments_features_data[${params.rowIndex}].feature`, event.target.label);
      params.context.methods.setValue(`card_management_feature_credit_payments_features_data[${params.rowIndex}].enabled`, event.target.checked);
      params.context.methods.trigger();
      params.context.handleValueChanges();
      params.api.refreshCells({ force: true });
    });
    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = this.params.data.enabled;
    return true;
  }
}
export class InputRenderer {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-input');
    this.input.type = 'text';
    this.input.value = params.data.alternativeMethod;
    this.input.disabled = !params.data.enabled;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.alternativeMethod = event.target.value;
      params.context.methods.setValue(`card_management_feature_credit_payments_features_data[${params.rowIndex}].alternativeMethod`, event.target.value);
      params.context.methods.trigger();
      params.context.handleValueChanges();
    });
    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.value = this.params.data.alternativeMethod;
    this.input.disabled = !this.params.data.enabled;
    return true;
  }
}
export class DetailCellRenderer {
  init(params) {
    const firstRecord = params.data;

    const form = document.createElement('form');
    form.classList.add('form'); // Add block class

    form.innerHTML = `
    <div class="form_div">
      <div class="form__group">
        <label for="callId" class="form__label">Call Id:</label>
        <i2c-input type="text" class="form__input" id="callId" value="${firstRecord.callId}"></i2c-input>
      </div>
      <div class="form__group">
        <label for="number" class="form__label">Number:</label>
        <i2c-input type="text" class="form__input" id="number" value="${firstRecord.number}"></i2c-input>
      </div>
      <div class="form__group">
        <label for="direction" class="form__label">Direction:</label>
        <i2c-input type="text" class="form__input" id="direction" value="${firstRecord.direction}"></i2c-input>
      </div>
    </div>  
  `;

    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
    /* Add your custom styles here */
    .form {
      background: var(--i2c-color-primary-25);
      padding:20px;
    }
    .form_div{
      padding: 20px;
      display: flex;
      width: calc(100% - 40px);
      margin: 20px auto;
      justify-content: space-between;
      border-radius: 4px;
      border: 1px solid var(--gray-200);
      background: var(--bg-primary);
      box-shadow: 0px 1px 2px 0px rgba(16,24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
      }
    .form__group {
      margin-bottom: 10px;
    }
    .form__label {
      display: block;
      font-weight: bold;
      color: var(--text-primary);
      margin-bottom: 10px;
    }
  `;

    const fragment = document.createDocumentFragment();
    fragment.appendChild(styleTag);
    fragment.appendChild(form);

    this.eGui = document.createElement('div');
    this.eGui.appendChild(fragment);
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    return false;
  }
}
